import { makeStyles } from "@material-ui/core/styles"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"
import { useHistory, useLocation } from "react-router"
import { useSelector } from "react-redux"
import { RootState } from "../../store/store"
import { fkLogo, arrowLeft } from "../../images"
import { useState, useEffect } from "react"
import { GlobeIcon } from "@fourkites/elemental-atoms"
import LanguageModal from "locale/languageModal"

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.12)",
    backgroundColor: "#fff"
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    color: "#21252A",
    letterSpacing: 0,
    fontFamily: "Lato",
    fontSize: "18px",
    fontWeight: "bold",
    lineHeight: "27px",
    cursor: "auto"
  },
  toolBar: {
    display: "flex",
    height: "64px",
    width: "100%"
  },
  arrowIcon: {
    marginRight: "12px",
    width: "28px",
    height: "28px",
    marginTop: "2px",
    cursor: "pointer"
  },
  logoIcon: {
    marginRight: "12px",
    cursor: "pointer"
  },
  helpIcon: {
    cursor: "pointer",
    marginLeft: "auto"
  }
}))

export default function ButtonAppBar() {
  const [headerUrl, setHeaderUrl] = useState("")

  const classes = useStyles()

  const [openModal, setOpenModal] = useState(false)
  const history = useHistory()
  const location = useLocation()
  const isGateLink = useSelector(
    (state: RootState) => state.facilityReducer.facility?.isGateLink || false
  )

  useEffect(() => {
    setHeaderUrl(location.pathname)
    // eslint-disable-next-line
  }, [location])

  const rootLocation = useSelector(
    (state: RootState) => state.locationReducer.location
  )

  const enabled = useSelector(
    (state: RootState) => state.locationReducer.enableAppBar
  )
  const closeModal = () => {
    setOpenModal(false)
  }
  return (
    <>
      {enabled && headerUrl !== "/" && (
        <div className={`${classes.root} headerBar`}>
          <AppBar color="inherit">
            <Toolbar className={`${classes.toolBar} headertoolBar`}>
              <>
                <img
                  src={headerUrl === "/support" ? arrowLeft : fkLogo}
                  className={
                    headerUrl === "/support"
                      ? classes.arrowIcon
                      : classes.logoIcon
                  }
                  alt={headerUrl === "/support" ? "arrowLeft" : "fkLogo"}
                  onClick={() =>
                    headerUrl === "/support"
                      ? history.go(-1)
                      : history.push(rootLocation)
                  }
                />
                <Typography variant="h6" className={classes.title}>
                  {headerUrl === "/support" ? "Support" : "Fast Track"}
                </Typography>
                <div className="globe-icon" onClick={() => setOpenModal(true)}>
                  <GlobeIcon size="28" />
                </div>
              </>
            </Toolbar>
          </AppBar>
          {openModal && <LanguageModal onClose={closeModal} />}
        </div>
      )}
    </>
  )
}
